// DLC Client Config
// import { isProd } from "../env";
import template from "./_template";

const hecooutage_config = {
  name: "hecooutage",
  disabled_features: {
    ...template.disabled_features,
    email: false,
  },
  enabled_features: {
    ...template.enabled_features,
    dataset_dip: true, // DLC-147 Whether to ENABLE client to "dip" datasets to find mobile phone numbers
    dataset_import: true,
    sso_microsoft_saml: true, // Whether Login page should display the Microsoft SSO button
    campaign_templates: true, // Whether to ENABLE the templates feature for the client DLC-78
    suppression_list: ["sms", "voice", "email"],
    wav_upload: true,
    voice_tts_dmf_enabled: true,
    //inbound_message: true,
  },
  sms: {
    short_codes: [
      // { label: "94230", value: "94230" }, // REST DLC-109 Removed as certification has completed for their shortcodes
      { label: "SC # 62761 Emergency", value: "62761" },
      { label: "SC # 76903 Scheduled", value: "76903" },
    ],
  },
  voice: {
    premium_options: [
      "premium_heco",
      "cantonese",
      "filipino",
      "japanese",
      "korean",
      "mandarin",
      "spanish",
      "vietnamese",
    ], // "all" || "premium" | "french" | "german" | "spanish"
    caller_id_options: [
      { label: "Select a phone number", isDisabled: true },
      { label: "(844) 483-8666 Emergency", value: "8444838666" },
      { label: "(855) 669-4761 Scheduled", value: "8556694761" },
      { label: "808-992-3072 Scheduled", value: "8089923072" },
    ],
  },
  email: {
    //NOT ACTIVATED in suppression screen drop down
    address_options: [
      { label: "Select Email", isDisabled: true },
      { label: "All", value: "" },
    ],
  },
};

export default hecooutage_config;
